<div
    appFileDrag
    class="upload-container"
    (fileDropped)="onFileDropped($event)"
>
    <div class="upload-cv-content">
        <input
            [disabled]="isPDFFileUploading"
            type="file"
            accept=".pdf,.doc,.docx,.jpg,.jpeg"
            #fileDropRef
            id="fileDropRef"
            (change)="fileBrowseHandler($event.target.files)"
        />
        <img
            class="upload-icon"
            src="assets/icons/icon_cv.svg"
        />
        <div class="upload-description flex-grow-1">
            <h2> {{ 'upload_cv.title' | translate }} </h2>
            <span>{{ 'upload_cv.description' | translate }}</span>
        </div>

        <hohr-button
            [disabled]="isPDFFileUploading"
            [label]="'upload_cv.browse_button' | translate"
            icon="share-outline"
            color="primary"
            fill="outline"
            slot="start"
            (action)="fileDropRef.click()"
        ></hohr-button>
    </div>

</div>
